var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1449_4616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95452 3.42676C2.49986 3.42676 2.06383 3.60737 1.74234 3.92886C1.42085 4.25035 1.24023 4.68639 1.24023 5.14104V21.4268C1.24023 21.8814 1.42085 22.3175 1.74234 22.6389C2.06383 22.9604 2.49986 23.141 2.95452 23.141H21.8117C22.2663 23.141 22.7024 22.9604 23.0238 22.6389C23.3453 22.3175 23.526 21.8814 23.526 21.4268V5.14104C23.526 4.68639 23.3453 4.25035 23.0238 3.92886C22.7024 3.60737 22.2663 3.42676 21.8117 3.42676H18.3831",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38281 0.856445V5.9993",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 0.856445V5.9993",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38281 3.42676H14.9542",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1046 10.6426L9.91186 17.8353L6.66016 18.2775L7.11797 15.0258L14.2951 7.83301L17.1046 10.6426Z",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_4616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.382812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEditIcon);
export default __webpack_public_path__ + "static/media/calendar-edit-icon.baecabc0783b20a4600e024b203e44c2.svg";
export { ForwardRef as ReactComponent };